<template>
  <div
    class="right-presentation"
    :class="{
      'mobile-active': $store.state.activeModelDetailSlide,
      'show-grid': showingSlideGrid,
      'app-lang-fr': isLangFr,
    }"
    @mouseup.stop
  >
    <TakeOverToolbar class="take-over--side-right" />
    <SyncLoadingAndMobileTurnOffTabContent v-if="$store.state.activeModelDetailSlide" />
    <ContentTemplateThumbnail
      v-if="currentUser.email === 'template@ahaslides.com' && slideActive.type === 'freestyle'"
    />
    <div
      v-if="slideActive.activeTab !== null"
      class="content-right-presentation"
    >
      <ActiveTab
        :selectedSlideIds="selectedSlideIds"
        :showingAudioTab="showingAudioTab"
        @activeTabSlide="activeTabSlide"
      />

      <div v-if="isDisableEditPresentation" class="overlay-disable-edit"></div>
      <div
        v-if="slideActive.activeTab == 1"
        class="tab-content-presentation"
      >
        <SlideTypeList wrapperId="right-side" class="pt-3" />
      </div>

      <VideoTutorial v-if="isShowVideoTutorial" />
      <ContentTab />
      <AISlideGeneratorModal v-if="slideGenerator.isAISlideGeneratorModalVisible" />

      <div
        v-if="slideActive.activeTab == 3"
        class="tab-content-presentation"
      >
        <BackgroundConfigV2 />
      </div>

      <div
        v-if="slideActive.activeTab == 4 && showingAudioTab"
        class="tab-content-presentation tab-content-presentation__audio-config"
      >
        <AudioConfig />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Constant from '@/constant'
import Config from '@/config'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

import BackgroundConfigV2 from '@/components/presentations/types/BackgroundConfig.v2.vue'
import AudioConfig from '@/components/presentations/types/AudioConfig.vue'
import TakeOverToolbar from '@/components-v2/presentation-editor/TakeOverToolbar.vue'
import ActiveTab from '@/components-v2/presentation-editor/side-right/ActiveTab.vue'
import ContentTab from '@/components-v2/presentation-editor/side-right/ContentTab.vue'
import SyncLoadingAndMobileTurnOffTabContent from '@/components-v2/presentation-editor/side-right/SyncLoadingAndMobileTurnOffTabContent.vue'
import AISlideGeneratorModal from '@/components-v2/presentation-editor/new-slide/OpenAI/AISlideGeneratorModal.vue'

import imageSubmissionTooltipImage from
  '@/assets/images/feature-update/image-submission-feature-update.svg'
import pollTooltipVideo from '@/assets/images/feature-update/poll.webm'
import VideoTutorial from '@/components-v2/presentation-editor/side-right/VideoTutorial.vue'
import ContentTemplateThumbnail from '@/components-v2/presentation-editor/side-right/ContentTemplateThumbnail'
import SlideTypeList from '@/components-v2/presentation-editor/new-slide/SlideTypeList.vue'

const noAudioTypes = new Set([
  'qrcode',
  'youtube',
  'googleSlides',
  'spinnerWheel',
])

export default {
  components: {
    BackgroundConfigV2,
    AudioConfig,
    TakeOverToolbar,
    ActiveTab,
    ContentTab,
    SyncLoadingAndMobileTurnOffTabContent,
    VideoTutorial,
    ContentTemplateThumbnail,
    AISlideGeneratorModal,
    SlideTypeList,
  },
  data() {
    return {
      activeTab: 1,
      envProduction: false,
      imageSubmissionTooltipImage,
      pollTooltipVideo,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
      isShowVideoTutorial() {
        const { videoTutorialUrl } = this.slideActive.typeObj || {}

        return !!videoTutorialUrl
      },
      presentation: (state) => state.presentation,
      presenterLocale: (state) => state.presenterLocale,
      slideGenerator: (state) => state.slideGenerator,
    }),
    isLangFr() {
      return this.presenterLocale === Constant.presenterLanguage.fr
    },

    showingAudioTab() {
      return this.$store.getters.selectedSlides.some(
        (s) => s.id && !noAudioTypes.has(s.type),
      )
    },
    isEURegion() {
      return Config.region === Constant.euRegion
    },
  },
  watch: {
    selectedSlideIds() {
      setTimeout(() => {
        if (this.selectedSlideIds.length > 1 && this.activeTab < 3) {
          this.activeTabSlide(3)
        } else if (noAudioTypes.has(this.$store.getters.selectedSlide.type)) {
          this.activeTabSlide(2)
        }
      }, 200)
    },
  },

  methods: {
    activeTabSlide(index) {
      this.$store.dispatch('updateSlideActive', {
        activeTab: index,
      })
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Right column > Switch tab', null, null, {
        slideId: this.slideActive.id,
        tabIndex: index,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
@import '@/assets/scss-v2/variables.scss';

.right-presentation {
  &.app-lang-fr {
    width: 415px;
  }
  width: $rightSideWidth;
  background-color: #fff;
  border-left: 1px solid #ebebeb;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  .content-right-presentation {
    position: relative;
    padding: 8px 10px 50px 16px;
    @media (max-width: 500px) {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}

.tab-content-presentation {
  padding: 0;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
  margin-top: 12px;
}

.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 w-full h-full;
  top: 44px;
  z-index: 9;
}

@media only screen and (max-width: 990px) {
  .right-presentation {
    width: 70%;
  }
}

@media only screen and (max-width: 767px) {
  .right-presentation {
    width: 100%;
    display: none;

    &.mobile-active {
      display: block;
    }
  }

  .mobile-active {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: #fff;
    z-index: 100;
    padding-top: 0;
    &::v-deep {
      .sync-error {
        top: 31px;
        left: -80%;
        .arrow-box::before {
          top: -11px;
          left: 62%;
        }
        .arrow-box::after {
          top: -10px;
          left: 62%;
        }
      }
    }
  }

  .sync-label {
    font-weight: bold;
    color: #888;
    i {
      margin-right: 5px;
      font-size: 20px;
    }
  }
}
@media (max-width: $ipad-breakpoint) {
  .right-presentation {
    width: 100%;
  }
  .right-presentation {
    &.show-grid {
      flex: 1;
    }
  }
}

.take-over--side-right {
  display: none;
}

.tab-content-presentation__audio-config {
  margin-top: 17px;
}

@media (max-width: $ipad-breakpoint) {
  .take-over--side-right {
    display: block;
  }
}

@media (max-width: 768px) {
  .take-over--side-right {
    display: none;
  }
}
</style>
